export default "__VITE_ASSET__CT0UnEny__"